<form [formGroup]="addressForm">
    <div class="mt-4 grid w-full min-w-0 grid-cols-1 gap-y-6 md:grid-cols-2 md:gap-x-4">
        <div>
            <vsf-form-field-label labelKey="address.fullName" forId="fullName" [required]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    formControlName="fullName"
                    autoComplete="name"
                    aria-required="true"
                    [class.border-red-500]="showError('fullName')"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                />
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('fullName')">{{ 'common.fieldRequired' | translate }}</p>
            </div>
        </div>

        <div class="md:col-span-2">
            <vsf-form-field-label labelKey="address.company" forId="company" [optional]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="company"
                    id="company"
                    formControlName="company"
                    aria-required="false"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div class="md:col-span-2">
            <vsf-form-field-label labelKey="address.address" forId="streetLine1" [required]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine1"
                    id="streetLine1"
                    formControlName="streetLine1"
                    autoComplete="street-address"
                    aria-required="true"
                    [class.border-red-500]="showError('streetLine1')"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('streetLine1')">{{ 'common.fieldRequired' | translate }}</p>
            </div>
        </div>

        <div class="md:col-span-2">
            <vsf-form-field-label labelKey="address.apartment" forId="streetLine2" [optional]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="streetLine2"
                    id="streetLine2"
                    formControlName="streetLine2"
                    aria-required="false"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div>
            <vsf-form-field-label labelKey="address.city" forId="city" [required]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="city"
                    id="city"
                    autoComplete="address-level2"
                    formControlName="city"
                    aria-required="true"
                    [class.border-red-500]="showError('city')"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('city')">{{ 'common.fieldRequired' | translate }}</p>
            </div>
        </div>

        <div>
            <vsf-form-field-label labelKey="address.country" forId="countryCode" [required]="true"></vsf-form-field-label>
            <div class="mt-1">
                <select
                    [class.border-red-500]="showError('countryCode')"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                    formControlName="countryCode" id="countryCode" aria-required="true">
                    <option *ngFor="let country of availableCountries" [ngValue]="country.code">
                        {{ country.name }}
                    </option>
                </select>
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('countryCode')">{{ 'common.fieldRequired' | translate }}</p>
            </div>
        </div>

        <div>
            <vsf-form-field-label labelKey="address.state" forId="province" [optional]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="province"
                    id="province"
                    formControlName="province"
                    autoComplete="address-level1"
                    aria-required="false"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div>
            <vsf-form-field-label labelKey="address.postalCode" forId="postalCode" [optional]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="text"
                    name="postalCode"
                    id="postalCode"
                    formControlName="postalCode"
                    autoComplete="postal-code"
                    aria-required="false"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
            </div>
        </div>

        <div class="md:col-span-2">
            <vsf-form-field-label labelKey="address.phone" forId="phoneNumber" [required]="true"></vsf-form-field-label>
            <div class="mt-1">
                <input
                    type="tel"
                    inputmode="numeric"
                    name="phoneNumber"
                    id="phoneNumber"
                    formControlName="phoneNumber"
                    autoComplete="tel"
                    aria-required="true"
                    [class.border-red-500]="showError('phoneNumber')"
                    class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500
            sm:text-sm"
                />
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('phoneNumber', 'required')">{{ 'common.fieldRequired' | translate }}</p>
                <p class="mt-1 text-xs text-red-500" *ngIf="showError('phoneNumber', 'pattern')">{{ 'common.invalidPhone' | translate }}</p>
            </div>
        </div>
    </div>
</form>
